import {Component, Input} from '@angular/core';
import { BzgModalService, BzgModalRef } from 'bz-genome-angular';
import { ListUsersComponent } from '../list-users/list-users.component';
import { select, Store } from '@ngrx/store';
import {
  getCurrentUserGroup,
  selectIsLoadingUserGroup,
  getViewStatus
} from '../store/selectors/current-user-groups.selector';
import { UpdateUserGroup, ResetCurrentUserGroup, CreateUserGroup, SetCurrentGroup } from '../store/actions/current-user-group.actions';
import { Subscription, Subject, Observable } from 'rxjs';
import { RequestPendingChanges, pendingChangesAction, validateChanges } from 'app/core/store/actions/pending-changes.actions';
import { selectPendingChangeAction, selectRequestValidation } from 'app/core/store/selectors/pending-changes.selector';
import { EPendingChangesSelectedAction } from 'app/core/models/pending-changes.enum';
import {EUserGroupMenuOptions} from '../../core/user-groups.enum';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'user-groups-detail',
  templateUrl: 'user-groups-detail.component.html',
  styleUrls: ['user-groups-detail.component.scss']
})

export class UserGroupsDetailComponent {
  @Input() menuOptions: {[key:string]: any};
  public currentUserGroup: IUserGroup;
  public isLoading: boolean;
  public modalRef: BzgModalRef;
  public viewStatus$: Observable<number>;
  private subscriptionCurrentUserGroup: Subscription;
  private subscriptionIsLoading: Subscription;
  private subscriptionCurrentGroupDebounce: Subscription;
  private _requestPendingChangesSuscription: Subscription;
  private _pendingChangesActionSubscription: Subscription;
  public userGroupMenuOptions = EUserGroupMenuOptions;
  public selectedTab: number = 0;

  constructor(private _modalService: BzgModalService, private _store: Store<IAppState>) {
    this.viewStatus$ = this._store.pipe(select(getViewStatus));
    this.subscriptionCurrentUserGroup = this._store.pipe(select(getCurrentUserGroup)).subscribe((userGroup) => {
      if (this.currentUserGroup && ( userGroup.id  === this.currentUserGroup.id)) {
        this.currentUserGroup = {
          ...userGroup,
          name: this.currentUserGroup.name,
          displayName: this.currentUserGroup.displayName,
          description: this.currentUserGroup.description
        }
      } else {
        this.currentUserGroup = _.cloneDeep(userGroup);
      }
    });
    this.subscriptionIsLoading = this._store.pipe(select(selectIsLoadingUserGroup)).subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });
    this._requestPendingChangesSuscription = this._store.pipe(select(selectRequestValidation)).subscribe((request) => {
      if (request) {
        this._store.dispatch(new validateChanges({userGroupModified: this.currentUserGroup}));
      }
    });
  }

  ngOnDestroy() {
    this.currentUserGroup = null;
    if (this.subscriptionCurrentUserGroup) {
      this.subscriptionCurrentUserGroup.unsubscribe();
    }
    if (this.subscriptionIsLoading) {
      this.subscriptionIsLoading.unsubscribe();
    }
    if (this.subscriptionCurrentGroupDebounce) {
      this.subscriptionCurrentGroupDebounce.unsubscribe();
    }
    if (this._requestPendingChangesSuscription) {
      this._requestPendingChangesSuscription.unsubscribe();
    }
    if (this._pendingChangesActionSubscription) {
      this._pendingChangesActionSubscription.unsubscribe();
    }
    this._store.dispatch(new ResetCurrentUserGroup());
  }

  ngOnInit() {
    this._pendingChangesValidationAction();
  }

  public save() {
    if (this.currentUserGroup.id) {
      this._store.dispatch(new UpdateUserGroup(this.currentUserGroup));
    } else {
      this._store.dispatch(new CreateUserGroup(this.currentUserGroup));
    }
  }

  public cancel() {
    this._store.dispatch(new RequestPendingChanges());
  }

  openUsersList() {
    this._modalService.open(ListUsersComponent, {
      closeOnRouterNavigation: true,
      height: 665,
      width: 956,
      maxWidth: 956
    });
  }

  updateCurrentUserGroup(property: string, value: any) {
    this.currentUserGroup = { ...this.currentUserGroup, [property]: value };
  }


  private _pendingChangesValidationAction () {
    this._pendingChangesActionSubscription = this._store
      .pipe(select(selectPendingChangeAction))
      .subscribe((action: EPendingChangesSelectedAction) => {
        switch (action) {
          case EPendingChangesSelectedAction.SAVE:
            this.save();
            break;
          case EPendingChangesSelectedAction.DONTSAVE:
            this._store.dispatch(
              new pendingChangesAction(EPendingChangesSelectedAction.CONTINUE)
            );
            break;
        }
      });
  }
}
